import { useEffect, useState } from "react";
import { TableCell } from "@material-ui/core";
import { TransparentInput } from "./TransparentInput";

interface EditableCellProps {
    value: any;
    onChange?: (newValue: any) => void | Promise<void>;
    onBlur?: (newValue: any) => void | Promise<void>;
    className?: string;
    multiline?: boolean;
    rows?: number;
}

export function EditableCell(props: EditableCellProps) {
    const [localValue, setLocalValue] = useState(props.value);

    const handleChange = (event: any) => {
        setLocalValue(event.target.value);
    }

    useEffect(() => {
        setLocalValue(props.value);
    }, [props.value]);

    const handleBlur = async () => {
        if (props.value === localValue) {
            return;
        }

        if (props.onChange) {
            await props.onChange(localValue);
        }

        if (props.onBlur) {
            await props.onBlur(localValue);
        }
    }

    return (
        <TableCell className={props.className}>
            <TransparentInput
                value={localValue}
                onChange={handleChange}
                onBlur={handleBlur}
                multiline={props.multiline}
                rows={props.rows}
            />
        </TableCell>
    );
}

interface EditableDateCellProps {
    value: any;
    onBlur?: (newValue: any) => void | Promise<void>;
}

const DELETE_SENTINEL = -1;

export function EditableDateCell(props: EditableDateCellProps) {
    const [localValue, setLocalValue] = useState("");

    // Convert Unix timestamp to localized string when component mounts or props.value changes
    useEffect(() => {
        if (!props.value) {
            setLocalValue("");
            return;
        }

        // Import formatUTC dynamically to avoid circular dependencies
        import("../lib/helpers.js").then(module => {
            setLocalValue(module.formatUTC(props.value));
        });
    }, [props.value]);

    const handleChange = (event: any) => {
        console.log(`EditableDateCell handleChange: ${event.target.value}`);
        setLocalValue(event.target.value);
    }

    const handleBlur = async () => {
        // Convert localized string back to Unix timestamp
        let patchValue = null;
        if (localValue.trim() === "") {
            patchValue = DELETE_SENTINEL;
        } else {
            const date = new Date(localValue);
            let val: number | null = Math.floor(date.getTime() / 1000);
            if (props.value === val) {
                return;
            }
            if (val && isNaN(val)) {
                val = null;
            }

            patchValue = val;
        }

        if (props.onBlur) {
            await props.onBlur(patchValue);
        }
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            e.target.blur();
        }
    }

    return (
        <TableCell>
            <TransparentInput
                value={localValue}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
            />
        </TableCell>
    );
}
